<template>
  <div class="modal-overlay" v-if="visible" @click.self="close">
    <div class="modal-box">
      <h3>{{ titleText }}</h3>
      <div v-if="record" class="detail-body">
        <!-- 基本信息 -->
        <div class="detail-group">
          <div class="group-title">基本信息</div>
          <div class="group-grid">
            <div class="detail-item"><span class="k">订单号</span><span class="v">{{ record.orderNo || '—' }}</span></div>
            <div class="detail-item"><span class="k">状态</span><span class="v">{{ record.status }}</span></div>
            <div class="detail-item"><span class="k">品种</span><span class="v">{{ record.symbolName }}</span></div>
            <div class="detail-item"><span class="k">方向</span><span class="v" :class="record.direction === 'buy' ? 'up' : 'down'">{{ record.direction === 'buy' ? '多' : '空' }}</span></div>
            <div class="detail-item"><span class="k">类型</span><span class="v">{{ record.orderType }}</span></div>
            <div class="detail-item"><span class="k">手数</span><span class="v">{{ record.lots != null ? record.lots : '—' }}</span></div>
            <div class="detail-item"><span class="k">杠杆</span><span class="v">{{ record.leverage || '—' }}X</span></div>
            <div class="detail-item"><span class="k">保证金</span><span class="v">{{ record.margin != null ? record.margin : '—' }}</span></div>
          </div>
        </div>
        <!-- 价格信息 -->
        <div class="detail-group">
          <div class="group-title">价格信息</div>
          <div class="group-grid">
            <div class="detail-item"><span class="k">开仓价</span><span class="v">{{ record.openPrice != null ? record.openPrice : '—' }}</span></div>
            <div class="detail-item">
              <span class="k">{{ record.isOpen ? '当前价' : '平仓价' }}</span>
              <span class="v">{{ record.isOpen ? (record.currentPrice != null ? record.currentPrice : '—') : (record.closePrice != null ? record.closePrice : '—') }}</span>
            </div>
            <div class="detail-item"><span class="k">开仓时间</span><span class="v">{{ record.openTime || '—' }}</span></div>
            <div class="detail-item"><span class="k">平仓时间</span><span class="v">{{ record.closeTime || '—' }}</span></div>
          </div>
        </div>
        <!-- 费用信息 -->
        <div class="detail-group">
          <div class="group-title">费用与盈亏</div>
          <div class="group-grid">
            <div class="detail-item"><span class="k">库存费</span><span class="v down">{{ fmtSwap(record.swap) }}</span></div>
            <div class="detail-item"><span class="k">手续费</span><span class="v">{{ record.fee != null ? record.fee : '—' }}</span></div>
            <div class="detail-item">
              <span class="k">{{ record.isOpen ? '浮动盈亏' : '盈亏' }}</span>
              <span class="v" :class="record.pnl > 0 ? 'up' : record.pnl < 0 ? 'down' : ''">{{ record.pnl != null ? fmtPnl(record.pnl) : '—' }}</span>
            </div>
            <div class="detail-item">
              <span class="k">净盈亏</span>
              <span class="v" :class="record.netProfit > 0 ? 'up' : record.netProfit < 0 ? 'down' : ''">{{ record.netProfit != null ? fmtPnl(record.netProfit) : '—' }}</span>
            </div>
          </div>
        </div>
        <p class="detail-hint">详情可在资金明细中查看关联流水。</p>
      </div>
      <div class="modal-btns"><button class="confirm" @click="close">关闭</button></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HistoryDetailModal',
  props: { visible: Boolean, record: Object },
  computed: {
    titleText() {
      if (!this.record) return '历史详情'
      const type = this.record.orderType || '交易'
      const symbolName = this.record.symbolName || '未知品种'
      return `${type} · ${symbolName}`
    }
  },
  methods: {
    close() { this.$emit('close') },
    fmtSwap(n) {
      const val = Number(n || 0)
      if (val === 0) return '0.00'
      return '-' + val.toFixed(2)
    },
    fmtPnl(n) {
      if (n == null) return '—'
      const sign = n > 0 ? '+' : ''
      return sign + (Math.trunc(Number(n) * 100) / 100).toFixed(2)
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-box {
  max-width: 480px;
  width: 90%;
  max-height: 85vh;
  overflow-y: auto;
}
.detail-body { margin-top: 8px; }
.detail-group { margin-bottom: 16px; }
.group-title {
  font-size: 13px; font-weight: 600; color: var(--text-secondary);
  margin-bottom: 8px; padding-bottom: 4px;
  border-bottom: 1px solid var(--border);
}
.group-grid {
  display: grid; grid-template-columns: 1fr 1fr; gap: 8px 16px;
}
.detail-item {
  display: flex; justify-content: space-between; align-items: center;
  font-size: 13px;
  .k { color: var(--text-secondary); }
  .v { font-weight: 600; }
  .up { color: var(--red); }
  .down { color: var(--green); }
}
.detail-hint {
  font-size: 12px; color: var(--text-muted); margin: 12px 0 0; line-height: 1.6;
}
.modal-btns {
  display: flex; gap: 12px; margin-top: 16px;
  button { flex: 1; padding: 10px; border-radius: 6px; border: none; cursor: pointer; font-family: inherit; font-weight: 600; }
  .confirm { background: var(--red); color: #fff; }
}
@media (max-width: 500px) {
  .group-grid { grid-template-columns: 1fr; }
}
</style>
